import { render, staticRenderFns } from "./popup_resource.vue?vue&type=template&id=4348dd6f&"
import script from "./popup_resource.vue?vue&type=script&lang=js&"
export * from "./popup_resource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PopupModal: require('/home/runner/work/mywellness-fiesta-2026/mywellness-fiesta-2026/user/components/popup_modal.vue').default})
